import Layout from "@/components/layout/Layout";
import SEOHead, { generateLocalBusinessSchema } from "@/components/seo/SEOHead";
import HeroSection from "@/components/home/HeroSection";
import SocialProofBar from "@/components/home/SocialProofBar";
import ServicesSection from "@/components/home/ServicesSection";
import WhyLuminateSection from "@/components/home/WhyLuminateSection";
import PortfolioSection from "@/components/home/PortfolioSection";
import VideoSection from "@/components/home/VideoSection";
import TestimonialsSection from "@/components/home/TestimonialsSection";
import ServiceAreasSection from "@/components/home/ServiceAreasSection";
import FinalCTASection from "@/components/home/FinalCTASection";

const HomePage = () => {
  return (
    <>
      <SEOHead
        title="Luminate Media | Real Estate Photography & Video in Washington & Arkansas"
        description="Professional real estate photography, cinematic video tours, drone aerials, and virtual tours. Serving Washington and Arkansas. Fast turnaround, stunning results."
        canonical="https://luminate.media"
        keywords="real estate photography, real estate video, drone photography, virtual tours, Washington real estate photography, Arkansas real estate photography"
        jsonLd={generateLocalBusinessSchema()}
      />
      <Layout>
        <HeroSection />
        <SocialProofBar />
        <ServicesSection />
        <WhyLuminateSection />
        <PortfolioSection />
        <VideoSection />
        <TestimonialsSection />
        <ServiceAreasSection />
        <FinalCTASection />
      </Layout>
    </>
  );
};

export default HomePage;
